import YvooaIcon from "../logo/YvooaIcon";

/**
 * YvooaInlineLoader — compact branded loading indicator using YvooaIcon.
 * Use inside dialogs, cards, or section panels (not full-screen).
 *
 * Props:
 *   message  string  (optional) text shown below, default "Loading..."
 *   size     number  (optional) icon size in px, default 32
 */
export const YvooaInlineLoader = ({ message = "Loading...", size = 32 }) => {
  const spinnerSize = size * 1.75;
  return (
    <div className="flex flex-col items-center justify-center py-8 gap-3">
      <div
        className="relative flex items-center justify-center"
        style={{ width: spinnerSize, height: spinnerSize }}
      >
        {/* Ping ring */}
        <div className="absolute inset-0 rounded-full border-2 border-blue-400/30 animate-ping" />
        {/* Spinning ring */}
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-500 border-r-yellow-400 animate-spin" />
        {/* Branded icon */}
        <YvooaIcon size={size} className="relative z-10" />
      </div>
      {message && (
        <p className="text-sm text-gray-500 dark:text-gray-400">{message}</p>
      )}
    </div>
  );
};

export const YvooaSpinner = () => (
  <div className="flex items-center justify-center w-full h-full min-h-[200px]">
    <div className="relative flex items-center justify-center">
      {/* Glowing background pulse */}
      <div className="absolute w-40 h-40 rounded-full bg-blue-500 opacity-20 blur-3xl animate-pulse"></div>

      {/* Outer glowing ring */}
      <div className="absolute w-28 h-28 border-4 border-blue-500/40 rounded-full animate-ping"></div>

      {/* Rotating gradient ring */}
      <div
        className="absolute w-24 h-24 border-4 border-transparent rounded-full animate-spin 
        border-r-yellow-400"
      ></div>

      {/* Yvooa Y logo */}
      <svg
        viewBox="0 0 100 100"
        width="60"
        height="60"
        className="relative z-10"
      >
        <defs>
          <linearGradient id="yGold" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#F9C642" />
            <stop offset="100%" stopColor="#FFD700" />
          </linearGradient>
        </defs>

        {/* Right arm of Y */}
        <polygon
          points="48,95 60,20 75,20"
          fill="#3b82f6"
          style={{ filter: "drop-shadow(0 2px 6px #1976d2aa)" }}
        />

        {/* Left arm of Y */}
        <polygon
          points="28,20 50,45 45,65"
          fill="url(#yGold)"
          style={{ filter: "drop-shadow(0 2px 6px #1976d2aa)" }}
        />
      </svg>
    </div>
  </div>
);
